import signUp from './en/signUp';
import resetPassword from './en/resetPassword';
import forceChangePassword from './en/forceChangePassword';

export default {
  signUp,
  resetPassword,
  forceChangePassword,
};
